var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Introduce,{style:([_setup.buttonStyle]),attrs:{"content":_setup.content}})
}
var staticRenderFns = []

export { render, staticRenderFns }